import type { LocalStateOps } from '@mimir/client-common/fileSync/localStateOps';
import type { AdobePanelContext, ElectronContext } from '@mimir/common/context/applicationContext';
import { getGlobalStore } from '@mimir/web/store';
import type { StorageProfile } from './storageSettings';

export async function storeDispatchLoadStorageProfile(
  applicationContext: AdobePanelContext | ElectronContext,
  toOpenPremiereProject: boolean,
  downloadPath: string,
  localStateOps: LocalStateOps,
): Promise<StorageProfile | undefined> {
  return await getGlobalStore().dispatch('loadStorageProfile', {
    applicationContext,
    toOpenPremiereProject,
    downloadPath,
    localStateOps,
  });
}
